import Feature9 from './Feature9'
export default Feature9
